import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import SelectByTwo from '../../../../generic/modals/SelectByTwo';
import ColumModal from '../../../../generic/Layouts/ColumModal';
import { PalletLogModal } from '../../../../generic/modals/PalletLogModal';
import { Surface, ScrollArea } from '../../../../generic/ui/Surface';
import { CreateButton, CreateFab } from '../../../../generic/ui/CreateButton';
import { AppModal } from '../../../../generic/ui/Modal';
import { PdfPreview } from '../../../../generic/ui/PdfPreview';
import { LINKS } from '../../../../Routs/config';
import useKosherTeudotList from './services/hooks/useKosherTeudotList';
import KosherTeudotPageLayout from './Components/KosherTeudotPageLayout';
import KosherTeudotSelectBar from './Components/KosherTeudotSelectBar';
import TeudaRow from './Components/TeudaRow';

type Props = {};

const KosherTeudotBody = (props: Props) => {
    const [t] = useTranslation(['teudot', 'buttons']);
    const {
        user,
        isDisabledHandleTeudot,
        isAllowToCreateTeudot,
        isAllowToSendSms,
        isMashgiah,
        setDefaultDate,
        selectedDate,
        setDate,
        setEndDate,
        handleDate,
        input,
        setInput,
        filterKoserList,
        selectedKosherID,
        handleFilterKosher,
        renderList,
        checkForUnSign,
        printPdf,
        pdfFile,
        handleSharePdf,
        handleDownloadPdf,
        handleOpenPdf,
        handleClearPdfFile,
        setSign,
        sendSms,
        printAll,
        handleStampFilter,
        handleOpenPalletLogModal,
        selectedTeuda,
        isOpenPalletLogModal,
        setIsOpenPalletLogModal,
        isOpenSelectByTwo,
        setIsOpenSelectByTwo,
    } = useKosherTeudotList();

    const canCreate = Boolean(
        (user?.rights.includes('OFFICE') ||
            user?.rights.includes('ADMIN') ||
            user?.rights.includes('DEV') ||
            isAllowToCreateTeudot) &&
            !isDisabledHandleTeudot,
    );

    const createTo = LINKS.teudot.teudotMishloah.createByID + 'new/new';
    const showStampButton = Boolean(isMashgiah && checkForUnSign && selectedKosherID);

    const isEmpty = !renderList || renderList.length === 0;
    const lastIndex = renderList.length - 1;

    return (
        <KosherTeudotPageLayout title={t('teudot:teudot_main_title')}>
            {pdfFile && (
                <AppModal
                    size='lg'
                    title='תצוגה מקדימה'
                    controlFunc={handleClearPdfFile}
                    Children={PdfPreview}
                    childrenProps={{
                        file: pdfFile,
                        handleSharePdf,
                        handleDownloadPdf,
                        handleClearFile: handleClearPdfFile,
                        handleOpenPdf,
                    }}
                />
            )}
            {isOpenPalletLogModal && (
                <ColumModal
                    title='לוג שינויים'
                    controlFunc={() => setIsOpenPalletLogModal(false)}
                    Children={PalletLogModal}
                    childrenProps={{
                        teudaNum: selectedTeuda?.Delivery_Num || 0,
                        teudaSub: selectedTeuda?.Delivery_Sub || 0,
                        orderNum: selectedTeuda?.Order_Num || 0,
                    }}
                />
            )}
            {isOpenSelectByTwo && (
                <SelectByTwo
                    label={'חותמת כשרות'}
                    open={isOpenSelectByTwo}
                    closeFunc={() => setIsOpenSelectByTwo(!isOpenSelectByTwo)}
                    selectFuncTwo={() => setIsOpenSelectByTwo(false)}
                    selectFuncOne={printAll}
                    chooseLableOne='לחתום את הכול'
                    chooseLabeTwo='חזרה'
                />
            )}

            <BarRow>
                {canCreate && <CreateButton to={createTo} label={t('buttons:new')} />}
                <KosherTeudotSelectBar
                    input={input}
                    setInput={setInput}
                    placeholder={t('teudot:teudot_main_search_placeholder')}
                    setDate={setDate}
                    setEndDate={setEndDate}
                    handleDate={handleDate}
                    selectedDate={selectedDate as Date | Date[]}
                    setDefaultDate={setDefaultDate}
                    isMashgiah={isMashgiah}
                    filterKoserList={filterKoserList}
                    selectedKosherID={selectedKosherID}
                    handleFilterKosher={handleFilterKosher}
                    showStampButton={showStampButton}
                    onStampClick={handleStampFilter}
                />
            </BarRow>

            <Surface>
                <ScrollArea>
                    {isEmpty ? (
                        <EmptyState>
                            <img src='/images/no-data.png' alt='empty data' />
                        </EmptyState>
                    ) : (
                        renderList.map((item, idx) => (
                            <TeudaRow
                                key={item.id ?? `${item.Delivery_Num}-${item.Delivery_Sub}`}
                                item={item}
                                isLast={idx === lastIndex}
                                isMashgiah={isMashgiah}
                                isAllowToSendSms={isAllowToSendSms}
                                isDisabledHandleTeudot={isDisabledHandleTeudot}
                                print={printPdf}
                                sign={setSign}
                                sendSms={sendSms}
                                handleOpenPalletLogModal={handleOpenPalletLogModal}
                            />
                        ))
                    )}
                </ScrollArea>
            </Surface>

            {canCreate && <CreateFab to={createTo} label={t('buttons:new')} />}
        </KosherTeudotPageLayout>
    );
};

export default KosherTeudotBody;

const BarRow = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-shrink: 0;
`;

const EmptyState = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;
`;
